import FeedbackModalTemplate from './feedback-modal.html';

class FeedbackModal {
    constructor() {
        'ngInject';
        angular.extend(this);
        
        this.isOpen = false;
        this.loading = false;
        this.document = {};
    }
    
    closeModal() {
        this.onCancel();
    }
    
    submitFeedback() {
        if (this.feedbackform.$valid) {
            this.loading = true;
            
        }
        
        /*
        this.AdminService.updateWebPage('delete', document).then((data) => {
            this.loading = false;
            if (data.statusCode === 200) {
                this.onComplete({$event: {success: true, message: data.message}});
            }
            else {
                this.onComplete({$event: {success: false, message: data.message}});
            }
        });
        */
    }
}

export default {
  bindings: {
      isOpen: '<',
      onComplete: '&',
      onCancel: '&'
  },
  controller: FeedbackModal,
  template: FeedbackModalTemplate
};



// WEBPACK FOOTER //
// ./src/search-interface/shared/components/feedback-modal/feedback-modal.js